namespace Ir.Components.Workbook.Settings.TabWidgetSettings {
    interface IViewModel {
        config: WorkbookConfig;
        dxScrollConfig: any;
        tabsConfig: any;
        activeTabItem: KnockoutObservable<SettingTabVM>;
    }

    interface IParams {
        config: WorkbookConfig
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;

        this.config = params.config;
        this.dxScrollConfig = {
            useNative: false,
        };

        let allTabs = [
            //Designer
            new SettingTabVM(ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                return this ? BaseWidget.getWidgetText(this().drilldownManager.getActiveWidget().widgetType) : "";
            }, self.config.activeTabOrWidget), ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                return this ? BaseWidget.getWidgetIcon(this().drilldownManager.getActiveWidget().widgetType) : "";
            }, self.config.activeTabOrWidget), 3, [WidgetType.Report, WidgetType.Pivot, WidgetType.Chart], null, null, "intro-settings-tab-designer"),

            //Properties
            new SettingTabVM(ko.computed(function (this: WorkbookConfig) {
                let type = this.activeTabOrWidget().widgetType();
                if (type == WidgetType.Report || type == WidgetType.Pivot || type == WidgetType.Chart) {
                    return "Properties";
                }
                
                return BaseWidget.getWidgetText(this.activeTabOrWidget().drilldownManager.getActiveWidget().widgetType);
            }, self.config), ko.computed(function (this: WorkbookConfig) {
                let type = this.activeTabOrWidget().widgetType();
                if (type == WidgetType.Report || type == WidgetType.Pivot || type == WidgetType.Chart) {
                    return "settings";
                }

                return BaseWidget.getWidgetIcon(this.activeTabOrWidget().drilldownManager.getActiveWidget().widgetType);
            }, self.config), 1, getEnumValuesExcept<WidgetType>(WidgetType as any, []) as any, null, null, "intro-settings-tab-properties"),

            new SettingTabVM("Visual", "display_settings", 2, getEnumValuesExcept<WidgetType>(WidgetType as any, [WidgetType.Report, WidgetType.Chart, WidgetType.Pivot, WidgetType.RichText]) as any),
            new SettingTabVM("General", "tune", 0, null, false, true),
        ];
        this.activeTabItem = ko.observable(allTabs.find(x => x.visible()));

        let tabsControl: DevExpress.ui.dxTabs;

        self.config.activeTabOrWidget.subscribe(function (newValue) {
            for (let tab of allTabs) {
                tab.setVisibility();
            }
            if (!self.activeTabItem().visible()) {
                self.activeTabItem(allTabs.find(x => x.visible()));
            }
        });

        this.tabsConfig = {
            items: allTabs,
            width: "100%",
            //height: "100%",
            animationEnabled: false,
            swipeEnabled: true,
            tabsPosition: "top",
            stylingMode: "secondary",
            iconPosition: "left",
            repaintChangesOnly: true,
            itemTemplate: titleTemplate,
            selectionMode: "single",
            selectedItem: this.activeTabItem,
            onInitialized: function (e) {
                tabsControl = e.component;
            },
        };
    }

    function titleTemplate(itemData: SettingTabVM, itemIndex, itemElement) {
        let $icon = $('<i>').text(typeof itemData.icon === "function" ? itemData.icon() : itemData.icon);

        // if (itemData.iconClass) {
        //     $icon.addClass(itemData.iconClass);
        // }
        // else {
        //     $icon.addClass("ms");
        // }

        $icon.addClass("ms");

        itemElement.append($icon);

        itemElement.append($('<span>').text(' ' + (typeof itemData.title === "function" ? itemData.title() : itemData.title)));

        if (itemData.templateClass) {
            itemElement.addClass(itemData.templateClass);
        }
    }
}